<template>
  <q-page class="docs-table" :style-fn="myTweak">
    <q-table
        :title="$t('recipients.bank_accounts.index')"
        ref="table"
        :data="serverData"
        :columns="columns"
        row-key="id"
        :visible-columns="visibleColumns"
        :loading="loading"
        style="margin:10px"
    >
      <!-- START CUSTOM COLUMNS -->
        <template v-slot:header="props">
            <q-tr :props="props">
                <q-th
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                >
                    {{ col.label }}
                </q-th>
            </q-tr>
        </template>
        <template v-slot:body="props">
            <q-tr :props="props">
                <q-td key="bank" :props="props">{{ props.row.bank }}</q-td>
                <q-td key="type" :props="props">{{ props.row.type }}</q-td>
                <q-td key="label1" :props="props"><b>{{ props.row.info_label1 }}: </b><br>{{props.row.number}}</q-td>
                <q-td key="label2" :props="props">
                    <div v-if="props.row.notes"><b>{{ props.row.info_label2 }}: </b><br>{{ props.row.notes }}</div>
                    <div v-else>-</div>
                </q-td>
                <q-td key="setting" :props="props" v-if="$auth.can('recipients.edit')">
                    <q-btn round size="sm" color="orange" icon="fa fa-edit" @click="edit(props.row)" />&nbsp;
                    <q-btn round size="sm" color="red" icon="fa fa-trash" @click="deleteRow(props.row)" :loading="loading"/>
                </q-td>
            </q-tr>
        </template>
      <!-- END CUSTOM COLUMNS -->
    </q-table>

    <bank-account-edit-modal
        :bank-account="selectedBankAccount"
        :currency-acronym="currencyAcronym"
        v-if="selectedBankAccount"
        v-model="displayBankAccountEditModal"
        @updated="updated"
    />

  </q-page>
</template>

<script>
  import BankAccount from "Modules/Bank/resources/models/BankAccount"
  import BankAccountEditModal from "Modules/Bank/resources/components/BankAccountEditModal.vue"
  export default {
    name: 'BankAccountList',
    props: {
        accounts: {
            type: Array,
            required: true
        },
        currencyAcronym: {
            type: String,
            required: true
        }
    },
    computed: {
	  columns() {
        return [
          {name: 'bank', label: this.$t('recipients.bank_accounts.bank'), align: 'left', field: 'bank', sortable: false},
          {name: 'type', label: this.$t('recipients.bank_accounts.type'), align: 'left', field: 'type', sortable: false},
          {name: 'label1', label: this.$t('recipients.bank_accounts.info_label1'), align: 'left', field: 'info_label1', sortable: false},
          {name: 'label2', label: this.$t('recipients.bank_accounts.info_label2'), align: 'left', field: 'info_label2', sortable: false},
          {name: 'setting', align: 'center', label: this.$t('recipients.bank_accounts.setting'), field: 'setting', sortable: false},
        ]
      },
    },
    data: () => ({
      separator: 'horizontal',
      filter: '',
      loading: false,
      serverData: [],
      selectedBankAccount: null,
      serverPagination: {
        page: 1,
        sortBy: 'id',
        rowsPerPage: 15,
        descending: false,
        rowsNumber: 10 // specifying this determines pagination is server-side
      },
      visibleColumns: ['bank', 'type', 'number', 'label1', 'label2', 'setting'],
      displayBankAccountEditModal: false
    }),
    methods: {
      edit(row) {
          this.selectedBankAccount = row
          this.displayBankAccountEditModal = true
      },
      deleteRow(row) {
          let account = new BankAccount({id: row.id})
          this.loading = true
          account.destroy(() => {
              this.serverData = this.serverData.filter(record => record.id !== row.id)
              this.loading = false
          }).catch(({data}) => {
              this.loading = false
          })
      },
      myTweak (offset) {
        return { minHeight: offset ? `calc(35vh - ${offset}px)` : '35vh' }
      },
      updated(data) {
        this.selectedBankAccount.notes = data.notes
        this.selectedBankAccount.number = data.number
        this.selectedBankAccount.type = data.type
        this.selectedBankAccount.bank = data.bank
      }
    },
    mounted() {
        this.serverData = this.accounts
    },
    components: {BankAccountEditModal}
  }
</script>
